import { createContext } from 'react';

interface Context {
  redirectUrl: string;
  isOrganic?: boolean;
  passedByRoleSelection?: boolean;
  setPassedByRoleSelection?: (value: boolean) => void;
}

export const AuthContext = createContext({} as Context);
export const AuthProvider = AuthContext.Provider;
